// extracted by mini-css-extract-plugin
export default {"b_s_adiv":"Btnsave_b_s_adiv__74IiO","b_s_img":"Btnsave_b_s_img__rw5F8","pressed":"Btnsave_pressed__QQWAA"};